
<template>
<!--  加开结果-->
  <div class="result">
<!--    不通过-->
    <template v-if="[9,10,11].includes(statusData)">
      <p class="p-title">{{ $t('openAccount.t000031') }}</p>
      <div class="error-list">
        <p class="item" v-for="item in errorData">{{item.pass_reason}}</p>
      </div>
      <nav-buttons
        :isFixed="false"
        :show-prev="false"
        :next-text="$t('deTopic.derivative.t50')"
        @on-next="submit"
      />
    </template>
    <template v-else>
      <div class="status-box">
        <!--        加开審核中-->
        <template v-if="statusData == 6">
          <img src="@/assets/images/account-activation-1.png" class="icon">
          <p class="title">{{ $t('openAccount.t000027') }}</p>
          <p class="text">{{ $t('mki18n.t00023') }}</p>
          <p class="text">{{ $t('mki18n.t00024') }}</p>
          <p class="text">{{ $t('mki18n.t00025') }} <a class="link" @click="showService">{{ $t('check_progress.status_tip_next') }}</a></p>
        </template>
        <!--      加开审核通过  -->
        <template v-if="statusData == 12 || statusData == 8">
          <img src="@/assets/images/account-activation-3.png" class="icon">
          <p class="title">{{ $t('openInstitutionServices.g000025') }}</p>
          <p class="text tc">{{ $t('mki18n.t00027') }} <a class="link" @click="showService">{{ $t('check_progress.status_tip_next') }}</a></p>
        </template>
      </div>
      <div class="step-box">
        <div class="item">
          <span class="label">{{ $t('check_progress.acceptance_sn_label') }}</span>
          <span class="text">{{ openAccountInfo.acceptance_sn }}</span>
        </div>
        <div class="item">
          <span class="label">{{ $t('check_progress.created_time_label') }}</span>
          <span class="text">{{ openAccountInfo.updated_at }}</span>
        </div>
        <div class="item">
          <span class="label">{{ $t('check_progress.progress_label') }}</span>
          <div class="text">
            <div class="text-left-line"></div>
            <template v-if="statusData == 6">
              <div class="text-item active">
                {{ $t("check_progress.step_first_name") }}
              </div>
              <div class="text-item ">
                {{$t('mki18n.t00030')}}
              </div>
            </template>
            <template v-if="statusData == 12 || statusData == 8">
              <div class="text-item ed">
                {{ $t('openAccount.t000002') }}
              </div>
              <div class="text-item active">
                {{$t('mki18n.t00030')}}
              </div>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import bus from "@/utils/bus";
import { setStatementDetailInfo } from "@/utils/hybirdMethods";
import NavButtons from "@/views/open-account/components/navButtons.vue";

export default {
  components: { NavButtons },
  data(){
    return {
      statusData: '',
      openAccountInfo: {},
      errorData: {}
    }
  },
  created() {
    this.account_type = this.$route.query.account_type;
    this.accountSituationV2()
  },
  methods: {
    accountSituationV2(){
      this.$apis.accountSituationV2().then(res =>{
        // 1 期货  2 证券
        this.openAccountInfo = res.get_open_account_info;
        this.statusData = res.account_status
        let error = {}
        if(this.account_type == 1){
          this.statusData = res.extra_open_info_hk.status || 0;
          if([9,10,11].includes(this.statusData)){
            error = res.extra_open_info_hk.open_info_record;
          }
        }else{
          this.statusData = res.extra_open_info_hb.status || 0;
          if([9,10,11].includes(this.statusData)){
            error = res.extra_open_info_hb.open_info_record;
          }
        }
        this.errorData = error;
        if(this.statusData != 0 && this.isApp){
          setStatementDetailInfo({
            headerTitle: this.$t('mki18n.t00033')
          });
        }
      })
    },
    showService(){
      bus.$emit('showService')
    },
    submit(){
      this.$router.push({
        path: "/open-account/accountProfile"
      })
    }
  }
}
</script>

<style scoped lang="less">
.result{
  padding: 0 32px;
  .p-title{
    font-weight: bold;
    font-size: 40px;
    line-height: 80px;
    padding-bottom: 20px;
    border-bottom: #F3F3F3 solid 1px;
  }
  .error-list{
    padding: 40px 0;
  }
}
.status-box{
  .icon{
    display: block;
    margin: 84px auto 0;
    width: 120px;
    height: 120px;
  }
  .title{
    font-weight: 500;
    font-size: 40px;
    margin: 44px 0;
    text-align: center;
  }
  .text{
    padding: 0 44px;
    margin-bottom: 10px;
    &.tc{
      text-align: center;
    }
    .link{
      color: #328CF4;
      text-decoration: underline;
    }
  }
}
.step-box{
  margin: 50px 48px 0;
  border-top: #F3F3F3 solid 1px;
  padding-top: 44px;
  .item{
    display: flex;
    line-height: 68px;
    font-size: 28px;
    .label{
      color: #747377;
      width: 40%;
      text-align: center;
    }
    .text{
      font-weight: 500;
      color: #17161C;
      position: relative;
      .text-left-line{
        position: absolute;
        left: 10px;
        width: 1px;
        top: 25px;
        bottom: 25px;
        background: rgba(0,0,0,0.06);
      }
      .text-item{
        position: relative;
        padding-left: 44px;
        &:before{
          content: '';
          position: absolute;
          left: 0;
          top: 23px;
          width: 20px;
          height: 22px;
          background: url("../../../assets/images/account-activation-6.png") no-repeat;
          background-size: 100% 100%;
        }
        &.error{
          color: #EE3A53;
        }
        &.active{
          &:before{
            background: url("../../../assets/images/account-activation-5.png") no-repeat;
            background-size: 100% 100%;
          }
        }
        &.ed{
          &:before{
            background: url("../../../assets/images/account-activation-4.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
  }
}
</style>